var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap doc_req_pop",
      staticStyle: { width: "900px", height: "600px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
      _c(
        "form",
        {
          attrs: { id: "frm_req_pop" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "popup_cont cod_cont_area" },
            [
              _c("h1", { staticClass: "page_title" }, [
                _vm._v(" Letter Of Indemnity (반송화물 비용 책임 각서) "),
              ]),
              _c("div", { staticClass: "content_box" }, [
                _c("p", { staticClass: "mt5" }, [
                  _c("span", [
                    _c(
                      "a",
                      {
                        staticClass: "button sm",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.excelDownload("ShipbackRequest2.xlsx")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("msg.ONEX050P190.031")))]
                    ),
                  ]),
                  _vm.memberDetail.userCtrCd === "KR" &&
                  _vm.$store.getters["auth/getCalcEiCatCd"] === "I"
                    ? _c("span", { staticClass: "ml5" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button sm",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.moveDelegateReqPage()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("msg.ONEX050P190.032")))]
                        ),
                      ])
                    : _vm._e(),
                  _vm.memberDetail.userCtrCd === "KR" &&
                  _vm.$store.getters["auth/getCalcEiCatCd"] === "I"
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            staticClass: "tbl_icon help ml10",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.guidePop()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("msg.ONEX050P190.033")))]
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("h2", { staticClass: "content_title" }, [
                  _vm._v(_vm._s(_vm.$t("msg.ONEX050P190.034"))),
                ]),
                _c("table", { staticClass: "tbl_row" }, [
                  _vm._m(0),
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v(_vm._s(_vm.$t("msg.ONEX050P190.035"))),
                      ]),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "filebox", attrs: { id: "file_att" } },
                          [
                            _vm.uploadParam.length === 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "button sm gray file",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.uploadFilePop()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("msg.ONEX050P190.036")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.uploadParam.length > 0
                              ? _c("div", [
                                  _c("span", {
                                    staticClass: "tbl_icon attach",
                                  }),
                                  _c("a", { staticClass: "text_link" }, [
                                    _vm._v(
                                      _vm._s(_vm.uploadParam[0].originalName)
                                    ),
                                  ]),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tbl_icon attdel",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeUploadFile()
                                        },
                                      },
                                    },
                                    [_vm._v("X")]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _c("td", { staticClass: "border_left_none" }),
                    ]),
                  ]),
                ]),
                _c(
                  "p",
                  {
                    staticClass: "txt_desc mt10",
                    staticStyle: { background: "none", "font-weight": "bold" },
                  },
                  [
                    _c("span", { staticClass: "font_medium" }, [
                      _vm._v("[" + _vm._s(_vm.$t("msg.ONEX050P190.025")) + "]"),
                    ]),
                    _vm._v(" TEL: 051-797-7400(내선 0) "),
                    _c("span", { staticClass: "txt_bar" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("msg.ONEX050P190.027")) +
                        " : doccs@ekmtc.com"
                    ),
                    _c("br"),
                  ]
                ),
                _c(
                  "p",
                  {
                    staticClass: "txt_desc mt10",
                    staticStyle: { background: "none", "font-weight": "bold" },
                  },
                  [
                    _vm._v(
                      " ※ 원선적지 SHIPBACK을 선택하셨습니다. SHIPBACK LOI를 첨부해 주시면 검토 후 최종 부킹 승인됩니다.문의 : doccs@ekmtc.com "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "mt10 text_right screen-to-pdf-hide" }, [
                _c(
                  "a",
                  {
                    staticClass: "button blue lg mr5",
                    on: {
                      click: function ($event) {
                        return _vm.reqSave()
                      },
                    },
                  },
                  [_vm._v("저장")]
                ),
                _c(
                  "a",
                  {
                    staticClass: "button gray lg",
                    on: {
                      click: function ($event) {
                        return _vm.confirmClose()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("msg.ONEX050P190.040")))]
                ),
              ]),
              _c(
                "win-layer-pop",
                { ref: "uploadPop", staticClass: "popup_dim" },
                [
                  _vm.customComponent
                    ? _c(_vm.customComponent, {
                        tag: "component",
                        attrs: {
                          "parent-info": _vm.uploadParam,
                          "single-file-yn": true,
                        },
                        on: {
                          "set-dext-file-info": _vm.arrangeUploadParam,
                          close: _vm.closePopup,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { id: "guide_pop" },
                },
                [
                  _vm.customComponent
                    ? _c(_vm.customComponent, {
                        tag: "component",
                        on: { close: _vm.closePopup },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "200px" } }),
      _c("col"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }